import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import Notification from "./Notification";
var Notice = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var notificationProps = _extends({
    showNotice: true
  }, props);
  return /*#__PURE__*/React.createElement(Notification, notificationProps);
});
export default Notice;